// src/components/Loader.jsx
export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-spinner" />
    </div>
  );
};